export default __webpack_public_path__ + "static/media/Background2aboutus.24c4d789.png";